<script lang="ts">
import { defineComponent, h } from 'vue';

export default defineComponent({
  inject: {
    registerColumn: { from: 'entListRegisterColumn', default: () => () => {} },
  },
  props: {
    field: { type: String, default: '' },
    label: { type: String, default: '' },
    /** 'title' | 'badge' | 'detail' | 'action' | 'hidden' */
    mobileRole: { type: String, default: 'detail' },
    sortable: { type: Boolean, default: true },
    /** Active un champ de filtre serveur « contient » sous l'en-tête de cette colonne. */
    filterable: { type: Boolean, default: false },
    thClass: { type: String, default: '' },
    tdClass: { type: String, default: '' },
  },
  mounted() {
    (this.registerColumn as (col: any) => void)({
      field: this.field,
      label: this.label,
      mobileRole: this.mobileRole,
      sortable: this.sortable,
      filterable: this.filterable,
      thClass: this.thClass,
      tdClass: this.tdClass,
      renderCell: (item: any) => {
        const slot = this.$slots.cell as any;
        return slot ? slot({ item }) : null;
      },
      /**
       * Rendu de la colonne sur une sous-ligne (ex. variantes d'un produit).
       * Absent = cellule vide sur les sous-lignes, ce qui laisse la colonne muette
       * plutôt que d'y répéter la valeur du parent.
       */
      hasSubCell: !!this.$slots.subcell,
      renderSubCell: (item: any, subItem: any) => {
        const slot = this.$slots.subcell as any;
        return slot ? slot({ item, subItem }) : null;
      },
    });
  },
  render() {
    return h('span', { style: { display: 'none' } });
  },
});
</script>
